import React from 'react'
import '../pages/OurMission.css'
import { Col, Container, Row } from 'react-bootstrap'
import ourmissionImg from '../assets/images/mission.png'
import FramedImage from '../components/FramedImage'

function OurMission() {
    return (
        <Container fluid className='missionContainer'>
            <Row className='align-items-center'>
                <Col md={6} className='mb-4 mb-md-0'>
                    <FramedImage src={ourmissionImg} alt='Our Mission' />
                </Col>

                <Col md={6}>
                    <h2 className='missionHeading'>Our Mission</h2>
                    <p className='missionText'>
                        At Resolution Experts Alliance Association, Our mission is to revolutionize the way disputes are resolved, empowering indivusals, businesses and organizations to navigate complex legal challenges with confidence and clearity.We believe that in a rapidly evolving world, traditional litigation can often fall short of meeting the dynamic needs of modern society. Our commitment is to provide a bridge to amicable resolutions, transparency and innovations.
                    </p>
                </Col>
            </Row>
        </Container>
    )
}

export default OurMission
